import { Injectable } from '@angular/core';
import { Equipement } from 'app/models/equipement.model';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { PieceEquipement } from 'app/models/pieceEquipement.model';

@Injectable({
  providedIn: 'root'
})
export class EquipementService {

  private API_URL= environment.API_URL;
  private MODEL_URL='equipements';

  constructor(private http: HttpClient) { }

  getEquipements(): Observable<Equipement[]> {
    return this.http.get<Equipement[]>(this.API_URL + this.MODEL_URL);
  }

  getEquipement(id: number): Observable<Equipement>{
    return this.http.get<Equipement>(this.API_URL + this.MODEL_URL + '/' + id).pipe(
      catchError(err => throwError(err))
    );
  }

  getPieceEquipements(piece_id: number): Observable<PieceEquipement[]> {
    return this.http.get<PieceEquipement[]>(this.API_URL + this.MODEL_URL + '/pieces/' + piece_id);
  }

  getPieceEquipementsLaissesParIdDossierIntervention(dossier_intervention_id): Observable<any> {
    return this.http.get<any>(this.API_URL + this.MODEL_URL + '/dossiers-interventions/' + dossier_intervention_id);
  }

  recupererEquipement(equipement_id: number, piece_id: number): Observable<PieceEquipement>{
    return this.http.post<PieceEquipement>(this.API_URL + this.MODEL_URL + '/' + equipement_id + '/pieces/' + piece_id + '/recuperation', null).pipe(
      catchError(err => throwError(err))
    );
  }

  storeForPiece(equipementForm){
    return this.http.post<boolean>(this.API_URL + this.MODEL_URL + '/pieces/' + equipementForm['piece_id'], equipementForm).pipe(
      catchError(err => throwError(err))
    );
  }

  store(equipement: Equipement): Observable<Equipement>{
    return this.http.post<Equipement>(this.API_URL + this.MODEL_URL, equipement).pipe(
      catchError(err => throwError(err))
    );
  }

  update(equipement: Equipement, id: number): Observable<Equipement>{
    return this.http.put<Equipement>(this.API_URL + this.MODEL_URL + '/' + id, equipement).pipe(
      catchError(err => throwError(err))
    );
  }

  delete(id: number): Observable<any>{
    return this.http.delete(this.API_URL + this.MODEL_URL + '/' + id).pipe(
      catchError(err => throwError(err))
    );
  }

}
